var Functions = Object;

import { utilities } from "./Utilities.js";
import { user } from "./User.js";
import { grant } from "./Grant.js";
import { list } from "./List.js";
import { order } from "./Order.js";
import { permission } from "./Permission.js";
import { grantApplication } from "./GrantApplication.js";
import { account } from "./Account.js";
import { organization } from "./Organization.js";
import { accountGroup } from "./AccountGroup.js";
import { responseTemplates } from "./ResponseTemplates.js";
import { glossary } from "./Glossary.js";
import { faq } from "./FAQ.js";
import { blog } from "./Blog";
import { category } from "./Category";
import { tutorial } from "./Tutorial";

Functions.install = function(Vue) {
  /*********** Accounts *************/
  Vue.prototype.$convertAccountTypeToOrganizationType =
    account.convertAccountTypeToOrganizationType;

  Vue.prototype.$getAccount = account.getAccount;

  Vue.prototype.$createAccount = account.createAccount;

  Vue.prototype.$updateAccount = account.updateAccount;

  Vue.prototype.$getAccountTypes = account.getAccountTypes;

  Vue.prototype.$getPaymentMethods = account.getPaymentMethods;

  Vue.prototype.$getAccountPermissions = account.getAccountPermissions;

  Vue.prototype.$getAccountOrganizations = account.getAccountOrganizations;

  Vue.prototype.$createDistrictContact = account.createDistrictContact;

  Vue.prototype.$updateDistrictContact = account.updateDistrictContact;

  /********** AccountGroups ***********/
  Vue.prototype.$createAccountGroup = accountGroup.createAccountGroup;

  Vue.prototype.$updateAccountGroup = accountGroup.updateAccountGroup;

  Vue.prototype.$getAccountGroups = accountGroup.getAccountGroups;

  Vue.prototype.$getGroupAccounts = accountGroup.getGroupAccounts;

  /************* Blog *************/
  Vue.prototype.$getAllBlogPosts = blog.getAllBlogPosts;
  Vue.prototype.$createPost = blog.createPost;
  Vue.prototype.$updatePost = blog.updatePost;
  Vue.prototype.$getBlogPost = blog.getBlogPost;
  Vue.prototype.$getReleasedBlogPosts = blog.getReleasedBlogPosts;
  Vue.prototype.$approveBlogPost = blog.approveBlogPost;

  Vue.prototype.$createPostCategories = blog.createPostCategories;
  Vue.prototype.$deletePostCategories = blog.deletePostCategories;

  /************** Category *************/
  Vue.prototype.$getAllCategories = category.getAllCategories;
  Vue.prototype.$createCategory = category.createCategory;

  /*********** Organizations ************/
  Vue.prototype.$createOrganization = organization.createOrganization;

  Vue.prototype.$updateOrganization = organization.updateOrganization;

  Vue.prototype.$deleteOrganization = organization.deleteOrganization;

  Vue.prototype.$getOrganizationTypes = organization.getOrganizationTypes;

  Vue.prototype.$getOrganization = organization.getOrganization;

  Vue.prototype.$getUsableOrganizationTypes =
    organization.getUsableOrganizationTypes;

  /********** Utilities *************/
  Vue.prototype.$displayDate = utilities.displayDate;

  Vue.prototype.$focusElement = utilities.focusElement;

  Vue.prototype.$goToURL = utilities.goToURL;

  Vue.prototype.$getStateCode = utilities.getStateCode;

  Vue.prototype.$phoneNumberCheck = utilities.phoneNumberCheck;

  Vue.prototype.$createSearchFlag = utilities.createSearchFlag;

  Vue.prototype.$createGrantFlag = utilities.createGrantFlag;

  Vue.prototype.$getIndeterminateValue = utilities.getIndeterminateValue;

  Vue.prototype.$showSnackbar = utilities.showSnackbar;

  Vue.prototype.$getClassForGrantApplicationStatus =
    utilities.getClassForGrantApplicationStatus;

  Vue.prototype.$getGrantStatusClass = utilities.getGrantStatusClass;

  Vue.prototype.$updateToggleIcon = utilities.updateToggleIcon;

  Vue.prototype.$filterResponsesToShow = utilities.filterResponsesToShow;

  Vue.prototype.$updateBudgetCol = utilities.updateBudgetCol;

  Vue.prototype.$getBudgetTotal = utilities.getBudgetTotal;

  Vue.prototype.$getBudgetSectionTotal = utilities.getBudgetSectionTotal;

  Vue.prototype.$getBudgetColType = utilities.getBudgetColType;

  /************ User ***************/
  Vue.prototype.$loadUser = user.loadUser;

  Vue.prototype.$updateLastFeedView = user.updateLastFeedView;

  Vue.prototype.$updateLastLogin = user.updateLastLogin;

  Vue.prototype.$updateUserOrganization = user.updateUserOrganization;

  Vue.prototype.$getAccountManagementUsers = user.getAccountManagementUsers;

  Vue.prototype.$getAccountManagementUserCount =
    user.getAccountManagementUserCount;

  Vue.prototype.$updateUser = user.updateUser;

  /*********** Grant ************/
  Vue.prototype.$getManageGrantsCount = grant.getManageGrantsCount;

  Vue.prototype.$getManageGrants = grant.getManageGrants;

  Vue.prototype.$getGrants = grant.getGrants;

  Vue.prototype.$getGrantsCount = grant.getGrantsCount;

  Vue.prototype.$createGrant = grant.createGrant;

  Vue.prototype.$createGrantNote = grant.createGrantNote;

  Vue.prototype.$updateGrant = grant.updateGrant;

  /*********** GrantApplication ************* */
  Vue.prototype.$getNotifications = grantApplication.getNotifications;

  Vue.prototype.$getGrantApplicationsForUser =
    grantApplication.getGrantApplicationsForUser;

  Vue.prototype.$updateGrantApplicationStatus =
    grantApplication.updateGrantApplicationStatus;

  Vue.prototype.$removeGrantApplication =
    grantApplication.removeGrantApplication;

  Vue.prototype.$getGrantApplication = grantApplication.getGrantApplication;

  Vue.prototype.$createGrantApplicationResponse =
    grantApplication.createGrantApplicationResponse;

  Vue.prototype.$createGrantApplicationResponseAnswer =
    grantApplication.createGrantApplicationResponseAnswer;

  Vue.prototype.$updateGrantApplicationResponseAnswer =
    grantApplication.updateGrantApplicationResponseAnswer;

  Vue.prototype.$removeGrantApplicationResponse =
    grantApplication.removeGrantApplicationResponse;

  Vue.prototype.$createGrantApplicationBudget =
    grantApplication.createGrantApplicationBudget;

  Vue.prototype.$updateGrantApplicationBudget =
    grantApplication.updateGrantApplicationBudget;

  Vue.prototype.$getGrantApplicationStatuses =
    grantApplication.getGrantApplicationStatuses;

  Vue.prototype.$getGrantApplicationStats =
    grantApplication.getGrantApplicationStats;

  Vue.prototype.$hideGrantApplication = grantApplication.hideGrantApplication;
  Vue.prototype.$unhideGrantApplication =
    grantApplication.unhideGrantApplication;

  /********** Order ***********/
  Vue.prototype.$orderTeachingSubjectsAlphabetically =
    order.orderTeachingSubjectsAlphabetically;

  Vue.prototype.$orderTeachingCategories = order.orderTeachingCategories;

  Vue.prototype.$orderAccountsByAccountGroupName =
    order.orderByAccountsByAccountGroupName;

  Vue.prototype.$orderByDateAdded = order.orderByDateAdded;

  Vue.prototype.$orderByDescriptionAlphabetically =
    order.orderByDescriptionAlphabetically;

  Vue.prototype.$orderByPermission = order.orderByPermission;

  Vue.prototype.$orderByName = order.orderByName;

  Vue.prototype.$orderByCategory = order.orderByCategory;

  /********** List **********/
  Vue.prototype.$createTeachingSubjectValueList =
    list.createTeachingSubjectValueList;

  Vue.prototype.$createTeachingGradeValueList =
    list.createTeachingGradeValueList;

  Vue.prototype.$createAwardLevelValueList = list.createAwardLevelValueList;

  Vue.prototype.$createStateValueList = list.createStateValueList;

  Vue.prototype.$createEligibilityValueList = list.createEligibilityValueList;

  Vue.prototype.$createTeachingSubjectDescriptionList =
    list.createTeachingSubjectDescriptionList;

  Vue.prototype.$createTeachingGradeDescriptionList =
    list.createTeachingGradeDescriptionList;

  Vue.prototype.$createStatesDescriptionList = list.createStatesDescriptionList;

  Vue.prototype.$createAwardLevelDescriptionList =
    list.createAwardLevelDescriptionList;

  Vue.prototype.$createEligibilityDescriptionList =
    list.createEligibilityDescriptionList;

  Vue.prototype.$createKeywordApplicabilityValueList =
    list.createKeywordApplicabilityValueList;

  /******* PERMISSIONS ********/
  Vue.prototype.$canManageGrants = permission.canManageGrants;

  Vue.prototype.$canAddNewGrants = permission.canAddNewGrants;

  Vue.prototype.$canApproveGrants = permission.canApproveGrants;

  Vue.prototype.$canManageAllAccounts = permission.canManageAllAccounts;

  Vue.prototype.$canManageMyAccount = permission.canManageMyAccount;

  Vue.prototype.$canManageOrganization = permission.canManageOrganization;

  Vue.prototype.$canManageTemplates = permission.canManageTemplates;

  Vue.prototype.$getAllPermissions = permission.getAllPermissions;

  Vue.prototype.$addPermissions = permission.addPermissions;

  Vue.prototype.$removePermissions = permission.removePermissions;

  Vue.prototype.$canAddBlogPost = permission.canAddBlogPost;

  Vue.prototype.$canApproveBlogPost = permission.canApproveBlogPost;

  Vue.prototype.$canManageBlog = permission.canManageBlog;

  /******* Response Templates ************/
  Vue.prototype.$getApplicationTemplateResponseCategories =
    responseTemplates.getApplicationTemplateResponseCategories;

  Vue.prototype.$getApplicationTemplateResponseCategoriesWithAnswers =
    responseTemplates.getApplicationTemplateResponseCategoriesWithAnswers;

  Vue.prototype.$createApplicationTemplateResponseCategory =
    responseTemplates.createApplicationTemplateResponseCategory;

  Vue.prototype.$updateApplicationTemplateResponseCategory =
    responseTemplates.updateApplicationTemplateResponseCategory;

  Vue.prototype.$createApplicationTemplateResponse =
    responseTemplates.createApplicationTemplateResponse;

  Vue.prototype.$updateApplicationTemplateResponse =
    responseTemplates.updateApplicationTemplateResponse;

  Vue.prototype.$createTemplateResponseBlankAnswer =
    responseTemplates.createTemplateResponseBlankAnswer;

  Vue.prototype.$updateTemplateResponseBlankAnswer =
    responseTemplates.updateTemplateResponseBlankAnswer;

  Vue.prototype.$removeTemplateResponseBlankAnswer =
    responseTemplates.removeTemplateResponseBlankAnswer;

  Vue.prototype.$cleanResponse = responseTemplates.cleanResponse;

  Vue.prototype.$archiveApplicationTemplateResponseCategory =
    responseTemplates.archiveApplicationTemplateResponseCategory;

  Vue.prototype.$archiveApplicationTemplateResponse =
    responseTemplates.archiveApplicationTemplateResponse;

  /******* Glossary ************/
  Vue.prototype.$getKeywords = glossary.getKeywords;

  Vue.prototype.$createKeyword = glossary.createKeyword;

  Vue.prototype.$updateKeyword = glossary.updateKeyword;

  Vue.prototype.$deleteKeyword = glossary.deleteKeyword;

  Vue.prototype.$getApplicableKeywords = glossary.getApplicableKeywords;

  /******* FAQ **********/
  Vue.prototype.$getFAQs = faq.getFAQs;

  Vue.prototype.$createFAQ = faq.createFAQ;

  Vue.prototype.$updateFAQ = faq.updateFAQ;

  Vue.prototype.$deleteFAQ = faq.deleteFAQ;

  /******* Tutorial **********/
  Vue.prototype.$getTutorials = tutorial.getTutorials;

  Vue.prototype.$createTutorial = tutorial.createTutorial;

  Vue.prototype.$updateTutorial = tutorial.updateTutorial;

  Vue.prototype.$deleteTutorial = tutorial.deleteTutorial;
};

export { Functions };
